<template>
	<db-row class="lazy-wrapper" :style="style" :width="width" :height="height" :id="id" valign="middle" align="center">
		<template v-if="type == 'IMG'">
			<img :style="imgStyle" :src="dataSrc" :class="[lazy ? 'lazy-init' : '', load ? lazyLoadClass : '']" v-if="load" />
		</template>
		<slot></slot>
	</db-row>
</template>

<script>
	import {Watcher} from '../../../model/observer/LazyObserver'
	import {ImageFitTypes} from '../../../enum'
	
	export default {
		name: 'lazy',
		
		props: {
			width: {
				type: [String, Number],
				default: 'auto'
			},
			
			height: {
				type: [String, Number],
				default: 'auto'
			},
			
			src: {
				type: String,
				default: ''
			},
			
			bgColor: {
				type: [String, Number],
				default: '#333'
			},
			
			type: {
				type: String,
				default: 'IMG'
			},
			
			background: {
				type: Boolean,
				default: false
			},
			
			fit: {
				type: String,
				default: ImageFitTypes.COVER
			},
			
			lazy: {
				type: Boolean,
				default: true
			}
		},
		
		data(){
			return {
				imgStyle: {},
				load: !this.lazy,
				dataSrc: this.lazy ? '' : this.src,
				id: 'lazy_' + Math.random(),
				lazyLoadClass: ''
			}
		},
		
		inject: ['regist', 'refresh'],
		
		computed: {
			style(){
				const style = {}
				if(this.bgColor){
					style.backgroundColor = (typeof this.bgColor === 'string') ? this.bgColor : '#' + this.bgColor
				}
				return style
			}
		},
		
		mounted(){
			const dom = document.getElementById(this.id)
			const watcher = new Watcher(dom, () => {
				this.render()
			})
			setTimeout(() => {
				const viewport = this.regist && this.regist(watcher)
			}, 100)
		},
		
		methods: {
			render(){
				if(this.type == 'IMG'){
					const image = new Image()
					image.src = this.src
					image.onload = () => {
						const {width, height} = image
						this.dataSrc = this.src
						this.load = true
						if(this.fit.toUpperCase() === ImageFitTypes.COVER){
							if(width >= height){
								Object.assign(this.imgStyle, {width: 'auto', height: '100%'})
							}else{
								Object.assign(this.imgStyle, {height: 'auto', width: '100%'})
							}
						}
						setTimeout(() => {
							this.lazyLoadClass = 'lazy-load'
							this.refresh()
							this.$emit('handler', this.src)
						}, 100)
					}
				}
			}
		}
	}
</script>

<style lang="scss" type="text/scss">
	.lazy-wrapper{
		
		.lazy-init{
			opacity: 0;
			transition: opacity .3s;
		}
		
		.lazy-load{
			opacity: 1.0;
		}
	}
</style>
